<div class="he-card rounded-md mb-3">
    <div class="he-card-body p-2">
        <ng-container *ngIf="notificationContent && !hideNotificationRangeFilter">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h1 class="fs-5 fw-bold mb-0">{{title}}</h1>
                <div class="d-flex align-items-center bg-white rounded-3 px-2">
                    <i class="fa-solid fa-calendar-days text-icon me-1" tooltip="Period" placement="bottom" container="body" [delay]="200"></i>
                    <app-dropdown
                        [optionsDDL]="notificationRangeOptions"
                        [control]="notificationRangeControl"
                        [placeholder]="'Period'"
                        (onChange)="onNotificationRangeSelect($event)">
                    </app-dropdown>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!(notificationContent && !hideNotificationRangeFilter)">
            <div *ngIf="tableContent" class="d-flex justify-content-between align-items-center gap-2 gap-md-3 mb-2 flex-wrap flex-md-nowrap table-card-header-row">
                <div class="min-w-0 flex-grow-1">
                    <h1 class="fs-5 fw-bold mb-0" *ngIf="title">{{title}}</h1>
                    <span class="fs-7 text-subheading d-block mt-1" *ngIf="description">{{description}}</span>
                </div>
                <div class="flex-shrink-0 ms-md-auto table-card-header-actions me-1">
                    <ng-content select="[card-table-header]"></ng-content>
                </div>
            </div>
            <ng-container *ngIf="!tableContent">
                <h1 class="fs-5 fw-bold mb-0" *ngIf="title">{{title}}</h1>
                <span class="fs-7 text-subheading" *ngIf="description">{{description}}</span>
            </ng-container>
        </ng-container>
        <div *ngIf="encounterContent" class="encounter-section">
            <div class="row g-3 row-cols-3">
                <ng-container *ngIf="encounterLoading">
                    <div class="col" *ngFor="let i of [1,2,3]">
                        <div class="card rounded-md my-2 encounter-skeleton-card">
                            <div class="card-body p-2 text-center d-flex flex-column align-items-center justify-content-center min-height-55">
                                <div class="encounter-skeleton encounter-skeleton-count"></div>
                                <div class="encounter-skeleton encounter-skeleton-label"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!encounterLoading">
                    <div class="col" *ngFor="let item of effectiveEncounterData">
                        <div class="card rounded-md my-2 bg-soft-gray"
                            [class.cursor-pointer]="isEncounterItemClickable(item)"
                            (click)="isEncounterItemClickable(item) && encounterItemClick.emit(item)">
                            <div class="card-body p-2 text-center text-{{item.color}}">
                                <h1 class="fs-5 fw-bold mb-0" [innerHTML]="(item.displayText ?? item.count) | formatTimeUnits | safeHtml"></h1>
                                <span class="fs-7">{{item.label}}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div *ngIf="leadTimeContent" class="lead-time-section">
            <div class="row g-2 row-cols-2">
                <ng-container *ngIf="leadTimeLoading">
                    <div class="col" *ngFor="let i of [1,2]">
                        <div class="card rounded-md my-2 encounter-skeleton-card">
                            <div class="card-body p-2 text-center d-flex flex-column align-items-center justify-content-center min-height-55">
                                <div class="encounter-skeleton encounter-skeleton-count"></div>
                                <div class="encounter-skeleton encounter-skeleton-label"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!leadTimeLoading">
                    <div class="col" *ngFor="let item of effectiveLeadTimeData">
<div class="card rounded-md my-2 bg-soft-gray">
                                <div class="card-body p-2 text-center text-{{item.color}}">
                                    <h1 class="fs-5 fw-bold mb-0" [innerHTML]="(item.displayText ?? item.count) | formatTimeUnits | safeHtml"></h1>
                                    <span class="fs-7">{{item.label}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
            </div>
        </div>
        <div *ngIf="scheduleContent">
            <div class="row g-3">
                <div class="col-6 col-md-4" *ngFor="let item of scheduleData">
                    <div class="he-metric-card my-2 bg-soft-gray">
                        <div class="he-metric-card__body p-2 text-center text-{{item.color}}">
                            <h1 class="fs-5 fw-bold mb-0">{{item.count}}</h1>
                            <span class="fs-7">{{item.label}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="prospectContent" class="prospect-section">
            <div class="row g-3">
                <ng-container *ngIf="prospectLoading">
                    <div class="col-6 col-md-3" *ngFor="let i of [1,2,3,4]">
                        <div class="card rounded-md my-2 prospect-skeleton-card">
                            <div class="card-body p-2 text-center d-flex flex-column align-items-center justify-content-center min-height-55">
                                <div class="prospect-skeleton prospect-skeleton-count"></div>
                                <div class="prospect-skeleton prospect-skeleton-label"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!prospectLoading">
                    <div class="col-6 col-md-3" *ngFor="let item of effectiveProspectMetrics">
                        <div class="card rounded-md my-2 prospect-metric-card bg-soft-gray"
                            [class.cursor-pointer]="isProspectItemClickable(item)"
                            (click)="isProspectItemClickable(item) && prospectItemClick.emit(item)">
                            <div class="card-body p-2 text-center text-{{item.color}}">
                                <h1 class="fs-5 fw-bold mb-0">{{item.count}}</h1>
                                <span class="fs-7">{{item.label}}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div *ngIf="visitContent">
            <app-week-picker title="Upcoming" description="Follow your weekly visits." customClass="h-100"
                [visitData]="upcomingWeekDays || []"
                (calendarStateChanged)="onCalendarStateChanged($event)"
                (dayCountSelected)="onDayCountSelected($event)"
                (weekChanged)="weekChanged.emit($event)"
                (dateSelected)="dateSelected.emit($event)">
            </app-week-picker>
            <div class="row g-3" style="margin-top: 13px;" *ngIf="!isCalendarOpen">
                <ng-container *ngIf="visitLoading">
                    <div class="col-6 col-md-3" *ngFor="let i of [1,2,3,4]">
                        <div class="card rounded-md my-2 visit-skeleton-card">
                            <div class="card-body p-2 text-center d-flex flex-column align-items-center justify-content-center min-height-55">
                                <div class="visit-skeleton visit-skeleton-count"></div>
                                <div class="visit-skeleton visit-skeleton-label"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!visitLoading">
                    <div class="col-6 col-md-3" *ngFor="let item of effectiveVisitData">
                        <div class="card rounded-md my-2 bg-soft-gray"
                            [class.cursor-pointer]="isVisitItemClickable(item)"
                            (click)="isVisitItemClickable(item) && visitItemClick.emit(item)">
                            <div class="card-body p-2 text-center text-{{item.color}}">
                                <h1 class="fs-5 fw-bold mb-0">{{item.count}}</h1>
                                <span class="fs-7">{{item.label}}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div *ngIf="ordersContent">
            <div class="row g-3">
                <div class="col-6 col-md-3" *ngFor="let item of ordersData">
                    <div class="he-metric-card my-2 bg-soft-gray">
                        <div class="he-metric-card__body p-2 text-center text-{{item.color}}">
                            <h1 class="fs-5 fw-bold mb-0">{{item.count}}</h1>
                            <span class="fs-7">{{item.label}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="engageContent">
            <div class="row g-3">
                <div class="col-6 col-md-4" *ngFor="let item of engageData">
                    <div class="he-metric-card my-2 bg-soft-gray">
                        <div class="he-metric-card__body p-2 text-center text-{{item.color}}">
                            <h1 class="fs-5 fw-bold mb-0">{{item.count}}</h1>
                            <span class="fs-7">{{item.label}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="notificationContent">
            <div class="row g-3">
                <div class="col-6 col-md-4" *ngFor="let item of effectiveNotificationItems; let i = index">
                    <div class="card rounded-md my-2 notification-item-card"
                        [class.cursor-pointer]="!notificationLoading && item.clickable !== false"
                        [ngClass]="notificationLoading ? 'notification-skeleton-card' : 'bg-soft-gray'"
                        (click)="!notificationLoading && onNotificationItemClick(item)">
                        <div class="card-body p-2 text-center"
                            [class.text-center]="true"
                            [ngClass]="notificationLoading ? '' : 'text-' + item.color">
                            <ng-container *ngIf="notificationLoading">
                                <div class="notification-skeleton notification-skeleton-count"></div>
                                <div class="notification-skeleton notification-skeleton-label"></div>
                            </ng-container>
                            <ng-container *ngIf="!notificationLoading">
                                <h1 class="notification-count fw-bold mb-0">{{item.value}}</h1>
                                <span class="fs-7">{{item.label}}</span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="tableContent" [ngClass]="customClass">
            <!-- <table class="table bg-white mt-3">
                <thead>
                    <tr>
                        <th>DOS</th>
                        <th>Name</th>
                        <th>Provider</th>
                        <th>Status</th>
                        <th>Location</th>
                        <th>Eligibility/Auth</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody class="fs-7 bg-white">
                    <tr *ngFor="let item of todayScheduleData">
                        <td>{{item.dos}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.provider}}</td>
                        <td><span class="badge bg-soft-primary text-primary p-2 rounded">{{item.status}}</span></td>
                        <td>{{item.location}}</td>
                        <td>{{item.eligibility}}</td>
                        <td class="text-end">
                            <span
                                [ngClass]="{'badge rounded p-2 text-success bg-soft-success': item.action === 'Checked-in', 'badge rounded p-2 text-primary bg-soft-primary': item.action !== 'Checked-in'}">{{item.action}}</span>
                            <div class="btn-group ms-3" dropdown container="body">
                                <i class="fa-solid fa-ellipsis-vertical dropdown-toggle ellipsis-btn" role="button"
                                    dropdownToggle data-toggle="dropdown" aria-expanded="true"></i>
                                <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                                    <span class="dropdown-item" role="button">
                                        <i class="fa fa-xmark-large me-2"></i>
                                        Cancel
                                    </span>
                                    <span class="dropdown-item" role="button">
                                        <i class="fa fa-trash-can me-2"></i>
                                        Delete
                                    </span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table> -->
            <ng-content select="[card-body]"></ng-content>
        </div>
    </div>
</div>